import { AnyObject } from '../application/commons/types';
import { useStubbornService, UseStubbornServiceOptions } from '../lib/StubbornService/react';

const SERVICE_ID = 'getLoggedUser';

export const useGetLoggedUser = (params: AnyObject, options: UseStubbornServiceOptions) => {
  return useStubbornService<AnyObject>(SERVICE_ID, params, options);
};
